module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAMAAACw0Z1uAAAAP1BMVEUAAACBh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh46Bh47s4MaEAAAAFHRSTlMA8aKXh5IoEuXb0sGxW046Cs5wbroBIFgAAABdSURBVBjTvdA5EoAwDEPRhOx7AN3/rLiJnaGhQ92r/ozUNqvtLkCLLgCG1UiV1TVQ5tIg5bDkSUkUgeiXQqKEKJPG0iykzokKoLEM6VY8SpxK5gAcm83Pdt/Wr9sfFVQGfWH9rYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/灰色左箭头@2x.png
// module id = y7EW
// module chunks = 0